<template>
  <div class="transparent">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-row-class-name="'tableHeader'"
    >
      <el-table-column
        width="69px"
        align="center">
        <template #default="{row}">
          <div
            class="flex-algin"
          >
            <p class="icon icon-text">
              <font-awesome-icon
                icon="user"
                class="icon-color"
              />
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="95px"
        label="Created">
        <template #default="{ row }">
          <div class="flex-algin time-text">
            <span>{{ row.created_at.split(" ")[0] }}</span><br>
            <span> {{ row.created_at.split(" ")[1] }}</span>
          </div>
          <p class="channel">{{row.source_language}}</p>
          <p class="channel">{{row.partner_language}}</p>
        </template>

      </el-table-column>
      <el-table-column
        width="95px"
        label="Adjustment Date">
        <template #default="{ row }">
          <div class="flex-algin time-text">
            <!--              <span>-->
            <span>{{ row.adjustment_date.split(" ")[0] }}</span><br>
            <span> {{ row.adjustment_date.split(" ")[1] }}</span>
            <!--              </span>-->
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="70"
        prop="id"
      >
        <template #default="{ row }">
          <!--            <span class="button-border">{{row.type_language}}</span>-->
          <div
            class="flex-algin">
            <span>
              <div class="flex  table-icon">
                <div v-if="row.company_id">
                  <span
                    v-tooltip="row.company_language"
                    class="icon icon-content"
                  >
                    <img
                      :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                    >
                  </span>
                </div>
                <div>
                  <span
                    v-tooltip="row.class_language"
                    class="icon icon-content"
                  >
                    <font-awesome-icon
                      v-if="row.class_id&& row.product_id!==80"
                      :icon="getOptionName('iconOptions', row.class_id)" />
                    <font-awesome-icon
                      v-else
                      icon="cube" />
                  </span>
                </div>
              </div>
              <div
                v-if="row.product_id!==80"
                class="flex table-icon margin-top-flex">
                <div>
                  <span
                    v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                    v-tooltip="extra_tip(row.extra_benefits_content,2)"
                    class="icon icon-content backgroud-width"
                  >
                    <font-awesome-icon
                      icon="wind" />
                  </span>
                </div>
                <div>
                  <span
                    v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1)) && extra_show(row.extra_benefits_content,1)==1"
                    v-tooltip="extra_tip(row.extra_benefits_content,1)"
                    class="icon icon-content backgroud-width"
                  >
                    <font-awesome-icon
                      icon="user-injured" />
                  </span>
                </div>
                <div>
                  <span
                    v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(4)) && extra_show(row.extra_benefits_content,4)==4"
                    v-tooltip="extra_tip(row.extra_benefits_content,4)"
                    class="icon icon-content backgroud-width"
                  >
                    <font-awesome-icon
                      icon="key" />
                  </span>
                </div>
              </div>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isTravel"
        label="Insurance Type">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span class="span-name">{{row.plan_type_language}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isMotor"
        label="Body Type">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span class="span-name">{{row.typ_of_bdy}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isPrivate"
        label="Car Info">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span class="span-name">{{row.make_model}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Policy">
        <template #default="{ row }">
          <div
            class="flex-algin"
          >
            <span class="span-label">{{ row.insurer }} {{  80>row.class_id>50?row.product_type:row.plan}}</span>
            <p
              v-if="row.pcy_no||row.cvr_nt_no"
              class="phone-text">
              <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
              <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
            </p>
            <span
              v-if="row.order_sn"
              class="phone-text">
              <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="105px"
        label="Policyholder">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="span-name">{{ row.policy_holder }}</span>
            <span>
              <template v-if="row.identity == 2">
                {{ row.contact_nm }}
              </template>
              <span class="phone-text"> {{ row.phone_no }}</span>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="89px"
        label="Referrer"
        prop="referrer_nm">
        <template #default="{ row }">
          <div class="flex-algin">
            <p class="first-text">
              <span
                v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
                class="unname">Unnamed</span>
              <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isMgm"
        label="Referrer's sign up Referrer"
        prop="referrer_nm">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="span-name">{{ row.referrer_referrer_isrd_nm }}</span>
            <p class="liter-text">{{ row.referrer_referrer_code }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="95"
        prop=""
        label="Period">
        <template #default="{ row }">
          <div class="flex-algin time-text">
            <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span>
            <span> {{ row.policy_period.split(" - ")[1] }}</span>
            <span
              v-if="row.is_eff_dt_delay && row.stts != 425"
              class="asap">ASAP</span>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="155px"
        label="Status">
        <template #default="{ row }">
          <div class="flex-algin">
            <p class="status-height">
              <span
                class="span-status"
                :class="{
                  'red': [801, 0].includes(row.stts),
                  'orange': [401, 301].includes(row.stts),
                  'yellow-dark': [410, 501, 701].includes(row.stts),
                  'blue': [420, 505, 705].includes(row.stts),
                  'green': [425, 510, 710].includes(row.stts)
                }">
                {{ row.stts_language }}
              </span>
            </p>
            <p
              v-for="(v,i) in row.tag_language"
              v-show="showStatus(v.id)"
              :key="i"
              class="status-height">
              <span
                class="span-options"
                :class="{
                  'gold': v.id == 1,
                  'blue': [2,16,64,256].includes(v.id),
                  'orange': v.id == 4,
                  'black': [8,32,128].includes(v.id),
                  'red': [512].includes(v.id),
                  'gray': [1024, 2048].includes(v.id)
                }">{{v.name}}</span>
            </p>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import MixinFormat from '@/mixins/format'
import MixinOption from '@/mixins/options'

export default {
  name: 'policyTableList',
  mixins:[MixinOption,MixinFormat],

  props:{
    tableData:{
      type:Array,
      default:()=>([])
    },
    isMgm:{
      type:Boolean,
      default:false
    },
    isMotor:{
      type:Boolean,
      default:false
    },
    isTravel:{
      type:Boolean,
      default:false
    },
    isPrivate:{
      type:Boolean,
      default:false
    },
  },
  computed:{
    showStatus(){
      return (id)=>{
        return id==1||id==1024
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name

      }
    },
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/marketing/marketing';

</style>
